import { graphql } from "gql";

const TAG_CATEGORY_QUERY = graphql(`
  query TagCategory($id: ID!) {
    tagCategory(id: $id) {
      ...TagCategory
    }
  }
`);

export default TAG_CATEGORY_QUERY;
